import React from "react";
import { MaterialDesignIcons } from "../styled";

export const SettingsMIcon: React.FC<{ fontSize: string }> = ({ fontSize }) => {
    return <MaterialDesignIcons fontSize={fontSize}>settings</MaterialDesignIcons>;
};
